<script setup>
import MonitoringManager from '@/views/apps/monitoring/list/MonitoringManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'bots',
    useBotNav: true,
  },
})

import { useRoute } from 'vue-router'

// Get the bot ID from the route params
const route = useRoute()
const botId = Number.parseInt(route.params.id)
</script>

<template>
  <!-- Old version of add new feedback -->
  <!--
    <FeedBack
    :bot-id="botId"
    :disable-user-question="false"
    :can-minimize="false"
    /> 
  -->
  
  <MonitoringManager
    :bot-id="botId"
    :card-view="false"
    :list-view="false"
    inline-add-new
    disable-bot-selection-in-add-new
  />
</template>
